import SubstrateSearchScenario from '../data/schema/SubstrateSearchScenario';
import { makeGetRequest } from 'owa-ows-gateway';
import { getSubstrateSearchEndpoint } from 'owa-search-service';
import buildQueryParams from 'owa-search-service/lib/helpers/buildQueryParams';
import { trace } from 'owa-trace';

/**
 * This route is responsible for providing completions/suggestions for the given prefix.
 * The type of suggestions returned would be based on the configuration done at 3S API.
 */
export default function substrateSearchSuggestionsService(
    queryString: string,
    searchSessionGuid: string,
    cvid: string,
    entityTypes: string,
    substrateSearchScenario: SubstrateSearchScenario,
    segmentTypes: string = '',
    customHeaders?: any
): Promise<Response> {
    const defaultParams = {
        cvid: cvid,
        query: encodeURIComponent(queryString),
        textdecorations: '1',
        scenario: substrateSearchScenario,
        entityTypes: entityTypes,
        segmentTypes: segmentTypes,
    };

    const params = buildQueryParams(defaultParams);

    if (searchSessionGuid) {
        return makeGetRequest(
            `${getSubstrateSearchEndpoint('suggestions')}?${params}`,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            customHeaders,
            undefined /* throwServiceError */,
            /* 3S does not need auth cookies so omitting them will decrease request header size */
            false /* includeCredentials */
        )
            .then(resp => {
                return resp;
            })
            .catch(err => {
                trace.warn(err);
                return null;
            });
    } else {
        return Promise.resolve(null);
    }
}
